import React from "react";

const Loader = () => {
  return (
    <div class="fixed inset-0 z-50 backdrop-blur-sm flex items-center justify-center bg-black/30 loader">
      <svg class="w-16 h-16 animate-spin text-white" viewBox="25 25 50 50">
        <circle
          class="stroke-current"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          stroke-width="4"
          stroke-linecap="round"
        ></circle>
      </svg>
    </div>
  );
};

export default Loader;
